import get from 'lodash.get';

import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectFertilizerEvents } from 'services/fertilizerEvents/selectors';
import { makeSelectQueryStringValue } from 'workspaces/react-router-selectors';
import {
    FertilizerEvent,
    FertilizerEventUuid
} from 'services/fertilizerEvents/types';

const selectFertilizerEvent = createDeepEqualSelector(
    [selectFertilizerEvents, makeSelectQueryStringValue('fertilizerEventUuid')],
    (
        fertilizerEventsState,
        fertilizerEventUuid: FertilizerEventUuid
    ): FertilizerEvent | undefined => {
        if (fertilizerEventUuid) {
            return get(fertilizerEventsState, fertilizerEventUuid);
        }

        return undefined;
    }
);

const selectFertilizerEventIsCompleted = createDeepEqualSelector(
    selectFertilizerEvent,
    (fertilizerEvent) => {
        if (!fertilizerEvent) {
            return false;
        }

        const completedAt = get(fertilizerEvent, ['jobs', 0, 'completedAt']);

        return Boolean(completedAt);
    }
);

const makeSelectFertilizerEventIsCompleted =
    (): typeof selectFertilizerEventIsCompleted =>
        selectFertilizerEventIsCompleted;

export { selectFertilizerEvent, makeSelectFertilizerEventIsCompleted };
